import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const queryInvoices = ({
  marinaSlug,
  reservationId,
  saleId,
  page,
  pageSize = 25,
}) => {
  const base = reservationId
    ? `/reservations/${reservationId}/invoices`
    : `/sales/${saleId}/invoices`
  return queryApi(
    `${base}?marina_slug=${marinaSlug}&non_zero_amount_or_canceled_with_reversal=true&page=${page}&page_size=${pageSize}`
  )
}

export const queryInvoiceTxns = ({
  invoiceId,
  marinaSlug,
  page,
  pageSize = 25,
}) => {
  return queryApi(
    `/invoices/${invoiceId}/invoice_txns?marina_slug=${marinaSlug}&page=${page}&page_size=${pageSize}`
  )
}

export const queryBillingContainerRefundablePaymentMethods = ({
  billingContainerId,
  marinaSlug,
  isSettling = false,
}) => {
  return queryApi(
    `/billing_containers/${billingContainerId}/refundable_payment_methods?marina_slug=${marinaSlug}&is_settling=${isSettling}`
  )
}

export const updateInvoice = ({ invoiceId, marinaSlug, data }) => {
  return mutateApi({
    url: `/invoices/${invoiceId}?marina_slug=${marinaSlug}`,
    method: "PATCH",
    data,
  })
}

export const createInvoiceTxn = ({ invoiceId, marinaSlug, data }) => {
  return mutateApi({
    url: `/invoices/${invoiceId}/txns?marina_slug=${marinaSlug}`,
    method: "POST",
    data,
  })
}

export const getConvenienceFeeCopy = ({ invoiceId, marinaSlug }) => {
  return queryApi(
    `/invoices/${invoiceId}/convenience_fee_copy?marina_slug=${marinaSlug}`
  )
}

export const mergeInvoices = ({
  sourceInvoiceId,
  destinationInvoiceId,
  marinaSlug,
}) => {
  return mutateApi({
    url: `/invoices/${sourceInvoiceId}/merge?marina_slug=${marinaSlug}`,
    method: "POST",
    data: {
      destination_invoice_id: destinationInvoiceId,
    },
  })
}

const buildContactInvoicesUrl = (path, marinaSlug, params = {}) => {
  const query = new URLSearchParams({ marina_slug: marinaSlug })
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return
    if (Array.isArray(value)) {
      value.forEach((v) => query.append(`${key}[]`, v))
    } else {
      query.append(key, value)
    }
  })
  return `${path}?${query.toString()}`
}

export const getContactInvoices = ({ contactId, marinaSlug, ...params }) =>
  queryApi(
    buildContactInvoicesUrl(
      `/contact/${contactId}/invoices`,
      marinaSlug,
      params
    )
  )

// Fetches all invoices matching the given filter set (no pagination) for the
// Export Summary print flow.
export const fetchContactInvoicesForPrint = ({
  contactId,
  marinaSlug,
  filters = {},
}) =>
  mutateApi({
    url: buildContactInvoicesUrl(
      `/contact/${contactId}/invoices/print`,
      marinaSlug
    ),
    method: "POST",
    data: { filters },
  })
